import { render, staticRenderFns } from "./StatsProvCareProgress.vue?vue&type=template&id=463c7be0&scoped=true&lang=html&"
import script from "./StatsProvCareProgress.vue?vue&type=script&lang=js&"
export * from "./StatsProvCareProgress.vue?vue&type=script&lang=js&"
import style0 from "./StatsProvCareProgress.vue?vue&type=style&index=0&id=463c7be0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c7be0",
  null
  
)

export default component.exports